import { userConstants } from '../_constants';


const initialState = {

};

export function user(state = initialState, action) {

  switch (action.type) {

    case userConstants.LOGIN_SUCCESS:
      let userInfo = action.loginSuccess;
      return userInfo || {};

    case userConstants.PROFILE_SUCCESS:
      let profileInfo = action.profileSuccess;
      return profileInfo || {};

    case userConstants.SIGNUP_SUCCESS:
      let signupInfo = action.signupSuccess;
      return signupInfo || {};

    // Changing the password (or failing to) keeps you signed in, so the
    // user stays. Clearing it here emptied the role until a reload: Settings
    // showed nothing and a self-employed stylist lost most of the side nav.
    case userConstants.CHANGEPASSWORD_SUCCESS:
      return state;

    case userConstants.CHANGEPASSWORD_ERROR:
      return state;

    case userConstants.LOGOUT_SUCCESS:
      return {};

    case userConstants.LOGIN_ERROR:
      return {};

    case userConstants.USER_CLEAR:
      return {};

    default:
      return state
  }
}

